/*
  Common toolbar title handlers
*/

export const editTitle = (localeMessage, doc) =>
  doc.firstCommitTime ? localeMessage('toolbar.label.edit') : localeMessage('toolbar.label.new');
